import { useCallback, useEffect, useState } from 'react';

import { getPackageSections } from '../../api/requests/packages';
import DisplayError from '../../components/info/DisplayError';
import { PackagesViewsSection } from '../../types/packageTypes';

export interface PackagesViewSectionsLoaderProps {
  packageId: number | string;
  children: (
    sections: null | PackagesViewsSection[],
    loading: boolean,
  ) => JSX.Element;
}

export const PackagesViewSectionsLoader = (
  props: PackagesViewSectionsLoaderProps,
) => {
  const { packageId, children } = props;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<PackagesViewsSection[] | null>(null);
  const [error, setError] = useState<'HTTP_ERROR' | 'CONNECTION' | null>(null);

  const fetchData = useCallback(async (id: string | number) => {
    setLoading(true);
    const response = await getPackageSections(id);
    if (response.data) {
      /**
       * Si es que hay data pero no ID entonces no lo encontró
       */
      setData(response.data);
    } else if (response.error) {
      setError(response.error.code);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData(packageId);
  }, [fetchData, packageId]);

  if (error) {
    return <DisplayError textBody={error} />;
  }

  return children(data, loading);
};
